import styled from "styled-components"

export const InputWrapper = styled.div`
  border-radius: 0.6rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.borderLight};
  padding-left: 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  flex: 1;
  max-width: 100%;

  .search-icon {
    width: 1.6rem;
    height: 1.6rem;
    color: ${({ theme }) => theme.colors.grey};
    margin-right: 1rem;
    flex-shrink: 0;
  }

  input {
    flex: 1;
    border: none;
    padding: 1rem 0;
    font-size: 1.4rem;
    outline: none;
    min-width: 0;
  }
`

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
  margin-bottom: 2rem;
`

export const FilterRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0.8rem;
  background-color: ${(p) => p.theme.colors.greyLighter};
  border: 1px solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.75rem;

  @media (min-width: 1200px) {
    flex-direction: row;
    align-items: center;
  }
`

export const FiltersGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  width: 100%;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0.8rem;
  background-color: ${(p) => p.theme.colors.greyLighter};
  border: 1px solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.75rem;

  @media (min-width: 1200px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: auto;
  }
`

export const MultiSelectWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  z-index: 3;
`

export const DatePickerWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const PeriodSelection = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0.8rem;
  flex-wrap: wrap;
`

export const PaginationSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  flex-wrap: nowrap;
  justify-content: flex-start;
  width: auto;
  
  @media (min-width: 1200px) {
    justify-content: flex-end;
    margin-left: auto;
  }
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${(p) => p.theme.colors.borderLight};
  margin: 0.8rem 0;

  @media (min-width: 1200px) {
    width: 1px;
    height: 2rem;
    margin: 0 1rem;
    flex-shrink: 0;
  }
`

export const IconWrapper = styled.div`
  display: none;
  height: 100%;
  align-items: center;

  svg {
    height: 2.8rem;
    margin-right: 0.8rem;
    margin-left: 1.5rem;
    color: ${({ theme }) => theme.colors.turquoiseDark};
  }

  @media (min-width: 768px) {
    display: flex;
  }
`

export const PaginationButton = styled.button<{ isActive: boolean }>`
  padding: 0.6rem 1.2rem;
  margin: 0 0.4rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 0.4rem;
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.colors.turquoiseDark : theme.colors.white};
  color: ${({ theme, isActive }) =>
    isActive ? theme.colors.white : theme.colors.textDark};
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: ${({ isActive }) => isActive ? '600' : '400'};
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background-color: ${({ theme, isActive }) =>
      isActive ? theme.colors.turquoiseDarker : theme.colors.greyLighter};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`
